module.exports = __webpack_public_path__ + "img/pethouse57.ca38b26e.jpg";